import { OrgOptimizerProcesses } from '@generated/graphql';
import { UserContext } from '@providers/userContextProvider';
import { useContext } from 'react';
import { Navigate } from 'react-router';
import { useBulkRebalanceEnabled } from '../hooks/useBulkRebalanceEnabled';

type BulkRebalanceRouteGuardProps = {
  children: React.ReactNode;
};

/** V2 bulk rebalance requires a V2 org and the Flagsmith `bulk_rebalance` flag. */
export const BulkRebalanceRouteGuard = ({
  children,
}: BulkRebalanceRouteGuardProps) => {
  const { activeOrganization } = useContext(UserContext);
  const bulkRebalanceEnabled = useBulkRebalanceEnabled();
  const isV2Org =
    activeOrganization.optimizerProcess ===
    OrgOptimizerProcesses.PortfolioOptimizerV2;

  if (!isV2Org) {
    return <Navigate to='/portfolioOptimizers' replace />;
  }

  if (!bulkRebalanceEnabled) {
    return <Navigate to='/' replace />;
  }

  return <>{children}</>;
};
